module.exports = __webpack_public_path__ + "img/bauplan.c62dfc3a.jpg";